"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedLanguages = void 0;
exports.isSupportedLanguage = isSupportedLanguage;
exports.getLanguageInfo = getLanguageInfo;
exports.getAllLanguagesInfo = getAllLanguagesInfo;
// Language list (BCP-47 primary subtags), aligned with backend support.
exports.SupportedLanguages = [
    "de", // German
    "el", // Greek
    "en", // English
    "es", // Spanish
    "fr", // French
    "it", // Italian
    "ja", // Japanese
    "ko", // Korean
    "pl", // Polish
    "ru", // Russian
    // 'th', // Thai - temporarily disabled (requires special word segmentation for practice)
    "tr", // Turkish
    "uk", // Ukrainian
    "zh", // Chinese
];
function isSupportedLanguage(code) {
    return !!code && exports.SupportedLanguages.includes(code);
}
/**
 * Get display information for a supported language
 * Used for consistent language presentation across all applications
 */
function getLanguageInfo(code) {
    const languageInfoMap = {
        de: { name: "German", nativeName: "Deutsch", flag: "🇩🇪" },
        el: { name: "Greek", nativeName: "Ελληνικά", flag: "🇬🇷" },
        en: { name: "English", nativeName: "English", flag: "🇺🇸" },
        es: { name: "Spanish", nativeName: "Español", flag: "🇪🇸" },
        fr: { name: "French", nativeName: "Français", flag: "🇫🇷" },
        it: { name: "Italian", nativeName: "Italiano", flag: "🇮🇹" },
        ja: { name: "Japanese", nativeName: "日本語", flag: "🇯🇵" },
        ko: { name: "Korean", nativeName: "한국어", flag: "🇰🇷" },
        pl: { name: "Polish", nativeName: "Polski", flag: "🇵🇱" },
        ru: { name: "Russian", nativeName: "Русский", flag: "🇷🇺" },
        tr: { name: "Turkish", nativeName: "Türkçe", flag: "🇹🇷" },
        uk: { name: "Ukrainian", nativeName: "Українська", flag: "🇺🇦" },
        zh: { name: "Chinese", nativeName: "中文", flag: "🇨🇳" },
    };
    // Note: Thai ('th') temporarily disabled - requires special word segmentation
    const info = languageInfoMap[code];
    return {
        code,
        ...info,
    };
}
/**
 * Get all supported languages with their display information
 */
function getAllLanguagesInfo() {
    return exports.SupportedLanguages.map(getLanguageInfo);
}
//# sourceMappingURL=languages.js.map